/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Msg_Member_PromotedInputs */

const en_msg_member_promoted = /** @type {(inputs: Msg_Member_PromotedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Member has been promoted to Moderator.`)
};

const es_msg_member_promoted = /** @type {(inputs: Msg_Member_PromotedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El miembro ha sido promovido a Moderador.`)
};

const fr_msg_member_promoted = /** @type {(inputs: Msg_Member_PromotedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le membre a été promu modérateur.`)
};

const de_msg_member_promoted = /** @type {(inputs: Msg_Member_PromotedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Mitglied wurde zum Moderator ernannt.`)
};

const id_msg_member_promoted = /** @type {(inputs: Msg_Member_PromotedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anggota telah dipromosikan menjadi Moderator.`)
};

/** @type {(inputs: Msg_Member_PromotedInputs) => LocalizedString} */
const ja_msg_member_promoted = en_msg_member_promoted;

/** @type {(inputs: Msg_Member_PromotedInputs) => LocalizedString} */
const zh_msg_member_promoted = en_msg_member_promoted;

/** @type {(inputs: Msg_Member_PromotedInputs) => LocalizedString} */
const ar_msg_member_promoted = en_msg_member_promoted;

/** @type {(inputs: Msg_Member_PromotedInputs) => LocalizedString} */
const it_msg_member_promoted = en_msg_member_promoted;

/** @type {(inputs: Msg_Member_PromotedInputs) => LocalizedString} */
const ru_msg_member_promoted = en_msg_member_promoted;

/** @type {(inputs: Msg_Member_PromotedInputs) => LocalizedString} */
const pt_msg_member_promoted = en_msg_member_promoted;

/** @type {(inputs: Msg_Member_PromotedInputs) => LocalizedString} */
const ko_msg_member_promoted = en_msg_member_promoted;

/**
* | output |
* | --- |
* | "Member has been promoted to Moderator." |
*
* @param {Msg_Member_PromotedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const msg_member_promoted = /** @type {((inputs?: Msg_Member_PromotedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Msg_Member_PromotedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_msg_member_promoted(inputs)
	if (locale === "es") return es_msg_member_promoted(inputs)
	if (locale === "fr") return fr_msg_member_promoted(inputs)
	if (locale === "de") return de_msg_member_promoted(inputs)
	if (locale === "ja") return ja_msg_member_promoted(inputs)
	if (locale === "zh") return zh_msg_member_promoted(inputs)
	if (locale === "ar") return ar_msg_member_promoted(inputs)
	if (locale === "id") return id_msg_member_promoted(inputs)
	if (locale === "it") return it_msg_member_promoted(inputs)
	if (locale === "ru") return ru_msg_member_promoted(inputs)
	if (locale === "pt") return pt_msg_member_promoted(inputs)
	return ko_msg_member_promoted(inputs)
});